import React, { useEffect, useState } from "react";

const CardDetailsUserImageDynamic = ({ data }) => {
  if (!data || data.length == 0) return null;

  const getComponent = (item, idx, size = null) => {
    item = item;
    switch (item?.tipo) {
      case "image":
        return (
          <figure
            id={idx+1}
            className="position-relative "
          >
            {!!item?.valor ? (
              <img
                style={{objectFit: 'cover', ...(size ? {width: size, height: size}: {})}}
                className={`rounded-circle bg-primary ${item?.classe}`}
                src={item?.valor}
              />
            ) : (
              <i className="far fa-user-circle user-photo-label" aria-hidden="true"
                style={{ fontSize: 150, lineHeight: 1 }} />
            )}
          </figure>
        );
      case "icone":
        return <i id={idx+1} className={item?.valor}></i>;
      case "texto":
        return (
          <p id={idx+1} className={item?.classe}>
            {item?.valor}
          </p>
        );
    }
  };

  return (
    <>
      {data?.map((item, idx) => (
        <div key={idx} className="row card-details-user-image-dynamic">
          {item?.Linhas?.map((item2, idx2) => (
            <div key={idx2} className="col-12">
              <div className="row">
                {item2?.map((item3, idx3) => (      
                  <>
                    {item3?.Linhas ? (
                      <div key={idx3} className={`${item3?.grid}`}>
                        {item3?.Linhas?.map((item4, idx4) => (
                          <>{getComponent(item4, idx4, 32)}</>
                        ))}
                      </div>
                    ) : 
                    <div key={idx3} className={`${item3?.grid}`}>
                      {getComponent(item3, idx3)}
                    </div> 
                  }
                  </>            
                ))}
              </div>
            </div>
          ))}
        </div>
      ))}
    </>
  );
};

export default CardDetailsUserImageDynamic;
